var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { SponsorshipFactoryABI } from '@streamr/network-contracts';
import { toEthereumAddress, toStreamID } from '@streamr/utils';
import { Interface } from 'ethers';
import { Lifecycle, inject, scoped } from 'tsyringe';
import { ConfigInjectionToken } from '../ConfigTypes';
import { StreamrClientEventEmitter } from '../events';
import { LoggerFactory } from '../utils/LoggerFactory';
import { ChainEventPoller } from './ChainEventPoller';
import { initContractEventGateway } from './contract';
let SponsorshipFactory = class SponsorshipFactory {
    config;
    constructor(chainEventPoller, config, eventEmitter, loggerFactory) {
        this.config = config;
        this.initEventListener(eventEmitter, chainEventPoller, loggerFactory);
    }
    initEventListener(eventEmitter, chainEventPoller, loggerFactory) {
        const transformation = ([sponsorshipContract, streamId], blockNumber) => ({
            sponsorshipContractAddress: toEthereumAddress(sponsorshipContract),
            streamId: toStreamID(streamId),
            blockNumber
        });
        const contractAddress = toEthereumAddress(this.config.contracts.sponsorshipFactoryChainAddress);
        const contractInterface = new Interface(SponsorshipFactoryABI);
        initContractEventGateway({
            sourceDefinition: {
                contractInterfaceFragment: contractInterface.getEvent('NewSponsorship'),
                contractAddress
            },
            sourceEmitter: chainEventPoller,
            targetName: 'sponsorshipCreated',
            targetEmitter: eventEmitter,
            transformation,
            loggerFactory
        });
    }
};
SponsorshipFactory = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(1, inject(ConfigInjectionToken)),
    __metadata("design:paramtypes", [ChainEventPoller, Object, StreamrClientEventEmitter,
        LoggerFactory])
], SponsorshipFactory);
export { SponsorshipFactory };
//# sourceMappingURL=SponsorshipFactory.js.map